import React from 'react';
import PropTypes from 'prop-types';

import { bonusesRoutes, CLIENT_PROFILE_COMPONENT_TYPES, clientProfileRoutes } from '@atlas/routing';

import BonusesHistory from 'components/ClientProfile/Bonuses/BonusesHistory/BonusesHistory';
import DepositBonuses from 'components/ClientProfile/Bonuses/DepositBonuses/DepositBonuses';
import FreeBets from 'components/ClientProfile/Bonuses/FreeBets/FreeBets';
import FreeSpins from 'components/ClientProfile/Bonuses/FreeSpins/FreeSpins';
import ClientProfileSubRouter from 'components/ClientProfile/ClientProfileSubRouter';

const { bonuses } = clientProfileRoutes;
const { bonusesDeposit, bonusesFreeBet, bonusesFreeSpins, bonusesHistory } = bonusesRoutes;

const getAvailableRoutes = clientProfilePath => ({
  [CLIENT_PROFILE_COMPONENT_TYPES.BONUSES_DEPOSIT]: {
    path: `${clientProfilePath}/${bonuses}/${bonusesDeposit}`,
    component: DepositBonuses,
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.BONUSES_FREEBET]: {
    path: `${clientProfilePath}/${bonuses}/${bonusesFreeBet}`,
    component: FreeBets,
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.BONUSES_BONUS_HISTORY]: {
    path: `${clientProfilePath}/${bonuses}/${bonusesHistory}`,
    component: BonusesHistory,
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.BONUSES_FREESPINS]: {
    path: `${clientProfilePath}/${bonuses}/${bonusesFreeSpins}`,
    component: FreeSpins,
  },
});

const BonusesRouter = ({ tabs }) => (
  <ClientProfileSubRouter
    getAvailableRoutes={getAvailableRoutes}
    parentRoute={bonuses}
    tabs={tabs}
  />
);

BonusesRouter.propTypes = { tabs: PropTypes.arrayOf(PropTypes.object) };

export default BonusesRouter;
